import { Button, Dropdown, Menu, message } from "antd";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { user_logs } from "../../actions/cards/cards";
import { apis } from "../../config/APIs";
import usePayAxios from "../../config/useAxios";
import useDownloadCSV from "../../config/useDownloadCSV";
import useDownloadPDF from "../../config/useDownloadPDF";
import { hasAccess } from "../../utils";
import Table from "../Common/Table/Table";
import PageHeader from "../PageHeader";

const UserLogs = () => {
  const dispatch = useDispatch();
  const downloadCSV = useDownloadCSV();
  const downloadPDF = useDownloadPDF();

  const { onCall: quickDownload, loading: quickLoading } = usePayAxios({
    api: apis.export_approval_logs,
    method: "get",
  });

  const [selectedKey, setSelectedKey] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);
  const tranferlogs = useSelector(
    (state) => state?.cards?.userLogs?.data?.response?.logs ?? [],
  );
  const totalRecords = useSelector(
    (state) => state?.cards?.userLogs?.data?.total_records ?? 0,
  );
  const tablLoading = useSelector((state) => state?.cards?.userLogs?.loading);

  React.useEffect(() => {
    dispatch(user_logs());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      title: "Date and Time",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (text, data) => {
        return (
          <div className={`render_common_style status_${data?.Status}`}>
            {text}
          </div>
        );
      },
    },
    {
      title: "User Email",
      dataIndex: "user_email",
      key: "user_email",
    },
    {
      title: "Checker Name",
      dataIndex: "checker_name",
      key: "checker_name",
    },
    {
      title: "Checker Email",
      dataIndex: "checker_email",
      key: "checker_email",
    },

    {
      title: "Checker Action",
      dataIndex: "checker_action",
      key: "checker_action",
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
    },
  ];

  const items = [
    { key: "", label: "All" },

    { key: "weekly", label: "Last 7 days" },
    { key: "monthly", label: "Last 30 days" },
    { key: "quarterly", label: "Last 3 months" },
    { key: "annually", label: "Last Year" },
  ];

  const menu = (
    <Menu
      onClick={(e) => {
        const today = moment();
        let dates = [];
        switch (e.key) {
          case "weekly":
            dates = [
              today.clone().subtract(1, "week").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "monthly":
            dates = [
              today.clone().subtract(1, "month").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "quarterly":
            dates = [
              today.clone().subtract(90, "days").format("YYYY-MM-DD"),
              today.clone().format("YYYY-MM-DD"),
            ];
            break;
          case "annually":
            dates = [
              today
                .clone()
                .subtract(1, "year")
                .startOf("year")
                .format("YYYY-MM-DD"),
              today
                .clone()
                .subtract(1, "year")
                .endOf("year")
                .format("YYYY-MM-DD"),
            ];
            break;
          default:
            dates = [null, null];
            break;
        }

        setSelectedKey(e.key);
        if (e.key !== "custom") {
          setSelectedDateRange(dates);

          dispatch(
            user_logs({
              period: e.key,
              start_date: dates[0] ? dates[0] : null,
              end_date: dates[1] ? dates[1] : null,
            }),
          );
        } else {
          setSelectedDateRange([]);
        }
      }}
      items={[...items]}
    />
  );
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );
  return (
    <>
      <div className="heading-div">
        <PageHeader
          title={`User Logs`}
          navigation={
            is_admin === "corporate"
              ? {}
              : {
                  Home:
                    hasAccess("dashboard", "read") ||
                    hasAccess("dashboard", "write")
                      ? "/dashboard"
                      : "",
                  "User Logs": "/checker/user-logs",
                }
          }
        />
      </div>
      <Table
        rowKey="id"
        columns={columns}
        data={tranferlogs}
        loading={tablLoading}
        isTopFilter={true}
        scroll={{ x: "max-content" }}
        filter={true}
        isSearch={true}
        isMore={true}
        pagination={{
          showTotal: (total, range) => {
            return `Showing ${range[0]} to ${range[1]} of ${total} entries`;
          },
          total: totalRecords,
          showSizeChanger: false,
          onChange: (pagee) => {
            dispatch(user_logs({ page: pagee }));
          },
        }}
        btnsComponent={null}
        hasExport={true}
        onExport={(val) => {
          quickDownload({ params: { format: val?.toLowerCase() } }).then(
            (res) => {
              // if (res.status) window.open(res?.response, "_blank");
              if (res.status) {
                if (val === "CSV") {
                  downloadCSV(res?.response, `user_log.csv`);
                } else {
                  downloadPDF(res?.response, `user_log.pdf`);
                }
              }
            },
          );
        }}
        addNewBtn={() => (
          <Dropdown overlay={menu} trigger={["click"]} className="mr1">
            <Button className="transaction-filter-dropdown">
              {selectedKey
                ? items.find((item) => item.key === selectedKey)?.label
                : "Select"}
            </Button>
          </Dropdown>
        )}
        exportLoading={quickLoading}
      />
    </>
  );
};

export default UserLogs;
